"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import styles from "./tab-selector.module.css";
import {cn} from "@/lib/utils";

export const Tabs = ({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Root>) => {
    return (
        <TabsPrimitive.Root
            data-slot="tabs"
            className={cn("flex flex-col", className)}
            {...props}
        />
    )
}

export const TabsList = ({className, ...props}: React.ComponentProps<typeof TabsPrimitive.List>) => {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                "bg-gray rounded-[12px] inline-flex items-center justify-center p-[4px]",
                className
            )}
            {...props}
        />
    )
}

export const TabsTrigger = ({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Trigger>) => {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(
                "text-noble-black-300 cursor-pointer rounded-[12px] font-semibold w-full py-[12px]",
                styles.TabTrigger,
                className
            )}
            {...props}
        />
    )
}

export const TabsContent = ({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Content>) => {
    return (
        <TabsPrimitive.Content
            data-slot="tabs-content"
            className={cn("flex-1", className)}
            {...props}
        />
    )
}
